import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { colors } from '../../../utils';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column'
    },
    paperHeader: {
      justifyContent: 'space-between'
    },
    justifyRight: {
      justifyContent: 'flex-end',
      alignItems: 'center'
    },
    withMarginLeft: {
      marginLeft: theme.spacing(1)
    },
    tableInfoChip: {
      marginLeft: theme.spacing(2),
      background: colors.defaultGrey
    },
    headerIcon: {
      color: theme.palette.primary.main
    },
    ml1: {
      marginLeft: theme.spacing(1)
    },
    mt2: {
      marginTop: theme.spacing(2)
    }
  });
});
